import React from 'react'

import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Divider from '@mui/material/Divider';

import parse from 'html-react-parser';

function RadioButton({ value, name, label, checked }) {
  
    return (
        <> 
            <FormControlLabel
                className='my-2'
                value={value}
                name={name}
                control={<Radio />}
                label={parse(label)}
                checked={checked}
            />
            <Divider />
        </>
    )
}

export default RadioButton;